import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import { toast } from 'sonner';
import api from '@/lib/api';

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const field = 'w-full rounded-lg border border-border bg-white py-2.5 pl-10 pr-3 text-sm outline-none focus:border-[hsl(var(--gaze-gold))]';

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error('This reset link is invalid or expired'); return; }
    if (password.length < 6) { toast.error('Password must be at least 6 characters'); return; }
    if (password !== confirm) { toast.error('Passwords do not match'); return; }
    setBusy(true);
    try {
      await api.post('/auth/reset-password', { token, password });
      toast.success('Password reset — please log in');
      navigate('/login');
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Could not reset password');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="container-gaze grid min-h-[70vh] place-items-center py-10">
      <div className="w-full max-w-md">
        <div className="text-center"><Link to="/" className="font-display text-3xl">Gaze Decor</Link><p className="mt-1 text-sm text-muted-foreground">Set a new password</p></div>
        <div className="mt-6 rounded-3xl border border-border bg-white p-6 sm:p-8">
          {!token ? (
            <p className="text-center text-sm text-muted-foreground">This reset link is invalid or has expired. Please request a new one from the login page.</p>
          ) : (
            <form onSubmit={submit} className="space-y-3" data-testid="reset-password-form">
              <div className="relative"><Lock size={16} className="absolute left-3 top-3 text-muted-foreground" /><input value={password} onChange={(e) => setPassword(e.target.value)} type="password" placeholder="New password" className={field} data-testid="reset-password-input" required /></div>
              <div className="relative"><Lock size={16} className="absolute left-3 top-3 text-muted-foreground" /><input value={confirm} onChange={(e) => setConfirm(e.target.value)} type="password" placeholder="Confirm new password" className={field} data-testid="reset-password-confirm-input" required /></div>
              <button type="submit" disabled={busy} data-testid="reset-password-submit" className="w-full rounded-full bg-[hsl(var(--primary))] py-3 text-sm font-semibold text-white disabled:opacity-60">{busy ? 'Please wait...' : 'Reset Password'}</button>
            </form>
          )}
          <Link to="/login" className="mt-4 block text-center text-xs text-[hsl(var(--primary))]">Back to login</Link>
        </div>
      </div>
    </div>
  );
}